import { CommonConfig } from "./common-config";
import { LogLevel } from "./log-level";

export class SharedConfig extends CommonConfig {
    logLevel: LogLevel = LogLevel.Info;
}